var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-layout"},[(_vm.userId == null)?_c('div',{staticClass:"check-login"},[_c('ChecklLogin')],1):_c('div',[_vm._v(" "+_vm._s(_vm.$route.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }